import React, { Component } from 'react';
import { Redirect, Link } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';

//import Updateokr from './updateokr';
//import 'react-datepicker/dist/react-datepicker.css';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import DataTable from 'react-data-table-component';
import AutoComplete from 'material-ui/AutoComplete';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Select from "react-select";
import { any } from 'prop-types';
import Form from "react-jsonschema-form";
import $ from 'jquery';
const MAX_LENGTH = 150;
const customStyles = {
    // cells: {
    //     style: {
    //       fontSize: '17px',
    //       paddingLeft: '0 8px',
    //     },
    //   },
    headCells: {
        style: {
            color: '#6cb5f9',
            fontSize: '13px',
            fontWeight: '800',
        },
    },
};

const dataSourceConfig = {
    text: 'title',
    value: 'id',
};
// ER70270 OKR enhancement
const dataSourceConfig1 = {
    text: 'title',
    value: 'id',
};
const schema = {}
const uiSchema = {}

const formData = {
    Owner: [],
    Quarter: 'id',
    //    keyresult: [{}],
    //    initiative: [{}],
    objective: '',
    keyRes: [{}]
};
// OKR enhancement ER end

class Listokr extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        var now = new Date();
        var currentYear = now.getFullYear();
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            fields: {},
            errors: {},
            message: '',
            week: '0',
            owners: [],
            owner: has_local_data ? localdata.user_id : '',
            quarter: [],
            all_quarters: [],
            all_years: [],
            objective: '',
            data: [],
            loading: false,
            totalRows: 0,
            perPage: 10,
            currentPage: 1,
            year: currentYear,
            ownerlist: has_local_data ? localdata.user_id : '',
            quarterlist: '',
            search: '',
            user_search: [],
            formData: {},
            okr_review: [],
            quarter: '',
            review_error_message: '',
            page_name: '',
            form: false,
            schema: schema,
            uiSchema: uiSchema,
            formData: formData,
            update: 0,
            objective: '',
            assign_to_new: '',
            UiSchema: {},
            search_popup: [],
            keyResult: [{ "child": [{}] }],
            deletePopup: "",
            keyres_index: "",
            intiative_index: "",
            initiative: [],
            show_errors: [],
            show_keyRes_errors: [],
            show_init_errors: [],
            selected_year: '',
            maxLength: 120,
            update_review_id: "",
            update_review_comment: "",
            radioChecked: false,
            whomToDelete: "",
            show_comment: "",
            maxLengthComment: 1000
        }
        this.submitUser = this.submitUser.bind(this);
        this.resetPopupForm = this.resetPopupForm.bind(this);
        this.addKeyResult = this.addKeyResult.bind(this);
        this.onChangeForm = this.onChangeForm.bind(this);
        this.handleValidation = this.handleValidation.bind(this);

        this.columns = [
            // {
            //     name: 'OKR Id',
            //     selector: 'okr_id',
            //     styles: {color: 'blue'},
            //     sortable: true,
            //     maxWidth: '10px',
            //     cell: row => <span><Link to={`/ViewOkr/${row.id}`}>{row.id}</Link></span>,  
            // },
            {
                name: 'Objective',
                selector: 'objective',
                width: '60%',
                cell: row => <span>{row.objective}</span>,
            },
            {
                name: 'Owner',
                selector: 'name',
                width: '20%',
                //sortable: true,
                cell: row => <span class="owner_okr_list"><Link to={`/viewEmployee/${row.user_id}`} name={"max"}>{row.name}</Link></span>,
            },
            {
                name: 'Quarter',
                selector: 'year_quarter',
                width: '10%',
                // sortable: true
            },
            {
                name: 'Action',
                width: '5%',
                ignoreRowClick: true, allowOverflow: true,
                //cell: row => <span class="view-okr">
                // <Link to={`/editokr/${row.id}`}><i class="fa fa-edit" aria-hidden="true"></i></Link>
                //</span>,
                cell: row => (row.current_year_quarter == row.year_quarter) ?
                    <span class="view-okr">
                        <Link to={`/editokr/${row.id}`}>
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3333 2.50004C11.5083 2.32494 11.7162 2.18605 11.945 2.09129C12.1738 1.99653 12.419 1.94775 12.6666 1.94775C12.9142 1.94775 13.1594 1.99653 13.3882 2.09129C13.617 2.18605 13.8248 2.32494 13.9999 2.50004C14.175 2.67513 14.3139 2.883 14.4087 3.11178C14.5034 3.34055 14.5522 3.58575 14.5522 3.83337C14.5522 4.08099 14.5034 4.32619 14.4087 4.55497C14.3139 4.78374 14.175 4.99161 13.9999 5.16671L4.99992 14.1667L1.33325 15.1667L2.33325 11.5L11.3333 2.50004Z" stroke="#666666" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </Link>
                    </span>
                    :
                    <span class="view-okr">
                        <Link to={`/viewOkr/${row.id}`}>
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.666504 8.41756C0.666504 8.41756 3.33317 3.08423 7.99984 3.08423C12.6665 3.08423 15.3332 8.41756 15.3332 8.41756C15.3332 8.41756 12.6665 13.7509 7.99984 13.7509C3.33317 13.7509 0.666504 8.41756 0.666504 8.41756Z" stroke="#666666" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M8 10.4175C9.10457 10.4175 10 9.52205 10 8.41748C10 7.31291 9.10457 6.41748 8 6.41748C6.89543 6.41748 6 7.31291 6 8.41748C6 9.52205 6.89543 10.4175 8 10.4175Z" stroke="#666666" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </Link>
                    </span>,
                //  conditionalCellStyles: [
                //  {
                //       when: row => row.status == "Successful",
                //       style: {
                //         backgroundColor: '#00b33cb3',
                //         color: 'black',
                //         fontweight:'bold'
                // },
                //     },
                //     {
                //       when: row => row.status == "Partly Successful",
                //       style: {
                //         backgroundColor: '#eded1599',
                //         color: 'black',
                //       },
                //     },
                //     {
                //       when: row => row.status == "Failed",
                //       style: {
                //         backgroundColor: '#f00c',
                //         color: 'black',
                //       },
                //     },
                //   ],
            },
        ];

        this.quarterChangelist = this.quarterChangelist.bind(this);
        this.searchChange = this.searchChange.bind(this);
        this.ChangePage = this.ChangePage.bind(this);
        this.ChangeRowsPerPage = this.ChangeRowsPerPage.bind(this);

    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    setReview(id, okr_id) {
        fetch(this.state.apiUrl + '/OkrRest/Getreview/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    okr_review: findresponse.review,
                    okr_id: okr_id,
                    update_keyresult: id
                })
            })
        this.setState({ update_review_id: '', update_review_comment: '', radioChecked: false, review_error_message: '', show_errors: [] }, function () {
            window.$("#changegrouptype").modal('show');
        });
    }

    handleReviewValidation(event, review_val) {
        var event_name = event.target.name;
        if (event_name == "review_id") {
            this.setState({ update_review_id: review_val, radioChecked: true });
        } else if (event_name == "review_comment") {
            var review_comment = review_val.trim();
            var show_errors = this.state.show_errors;

            if (review_comment.length > 1 && review_comment.length < this.state.maxLengthComment) {
                show_errors['comment_error'] = "";
            } else if (review_comment.length == this.state.maxLengthComment) {
                show_errors['comment_error'] = "Max 1000 characters allowed";
            }
            this.setState({ update_review_comment: review_val, show_errors });
        }
    }

    SaveGroupType() {
        let review_error_message = '';
        if (this.state.update_review_id == undefined || this.state.update_review_id == 0) {
            review_error_message = "Please choose a status to review";
            this.setState({ review_error_message: review_error_message });
            return false;
        }
        this.setState({ waiting: 'loading' });
        var review_data = {};
        review_data['review_id'] = this.state.update_review_id;
        review_data['review_comment'] = this.state.update_review_comment.trim();
        review_data['okr_id'] = this.state.okr_id;
        review_data['key_result_id'] = this.state.update_keyresult;
        review_data['userId'] = this.state.userId;
        fetch(this.state.apiUrl + '/OkrRest/savereview/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(review_data),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                this.setState({ waiting: '' });
                this.setState({ review_error_message: '' });
                window.$("#changegrouptype").modal('hide');
                this.GetOkrListing(this.state.ownerlist, this.state.quarterlist, this.state.yearlist, this.state.search, this.state.perPage, this.state.currentPage);
            })
    }

    ChangePage(page, totalRows) {
        this.GetOkrListing(this.state.ownerlist, this.state.quarterlist, this.state.yearlist, this.state.search, this.state.perPage, page);
    }

    ChangeRowsPerPage(currentRowsPerPage, currentPage) {
        //console.log(currentRowsPerPage);
        var obj = this;
        // this.setState({currentPage:currentPage,perPage: currentRowsPerPage });
        this.GetOkrListing(this.state.ownerlist, this.state.quarterlist, this.state.yearlist, this.state.search, currentRowsPerPage, currentPage);
        //console.log(this.state.perPage);
    }

    quarterChangelist(event, srch_fld) {
        if (srch_fld == "yearlist") {
            localStorage.setItem('yearlist', event.target.value);
            //            let quarter = event.target.value;
            this.setState({
                yearlist: event.target.value, currentPage: this.state.currentPage,
            }, function () {
                this.GetOkrListing(this.state.ownerlist, this.state.quarterlist, this.state.yearlist, this.state.search, this.state.perPage, this.state.currentPage);
            });
        } else if (srch_fld == "quarterlist") {
            localStorage.setItem('quarterlist', event.target.value);
            this.setState({
                quarterlist: event.target.value, currentPage: this.state.currentPage,
            }, function () {
                this.GetOkrListing(this.state.ownerlist, this.state.quarterlist, this.state.yearlist, this.state.search, this.state.perPage, this.state.currentPage);
            });
        }
    }

    searchChange(event) {
        var obj = this;
        this.setState({ search: event.target.value, currentPage: this.state.currentPage });
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        let search_val = document.getElementById('search').value;

        localStorage.setItem('search', search_val);

        //Execute the function code here...
        obj.GetOkrListing(obj.state.ownerlist, obj.state.quarterlist, obj.state.yearlist, search_val, this.state.perPage, this.state.currentPage);
    }

    Reset() {
        // URL
        //        var year_quarter = ((this.state.quarter).includes('20'))?this.state.quarter:(this.state.year +' '+ this.state.quarter);
        var selected_year = this.state.selected_year;
        var quarter = this.state.quarter;
        this.setState({
            search: '', currentPage: this.state.currentPage, quarterlist: quarter, ownerlist: this.state.user_id
        }, function () {
        });

        localStorage.setItem('quarterlist', quarter);
        localStorage.setItem('yearlist', selected_year);
        localStorage.setItem('ownerlist', this.state.user_id);

        this.getOwnerName(this.state.user_id);
        this.setState({ yearlist: selected_year, quarterlist: quarter }, function () {
            this.GetOkrListing(this.state.user_id, quarter, selected_year, '');
        })
    }

    GetOkrListing(okr_owner = '', okr_quarter = '', okr_year = '', okr_search = '', per_page = 10, curpage = 1) {
        this.setState({ loading: true });
        this.setState({ update_review_id: 0 });

        this.setState({ currentPage: curpage, perPage: per_page });

        // let per_page = this.state.perPage;
        // let curpage = this.state.currentPage;

        this.state.fields['ownerlist'] = okr_owner == 'all' ? '' : okr_owner;

        this.state.fields['quarterlist'] = okr_quarter == 'all' ? '' : okr_quarter;
        this.state.fields['yearlist'] = okr_year == 'all' ? '' : okr_year;

        this.state.fields['search'] = okr_search == '' ? '' : okr_search;

        this.state.fields['offset'] = ((curpage - 1) * per_page);

        this.state.fields['limit'] = per_page;

        fetch(this.state.apiUrl + '/OkrRest/ListingOkr/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state.fields),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {

                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    data: findresponse.total_okr,
                    totalRows: findresponse.item_count,
                    loading: false,
                    quarter: findresponse.quarter,
                    selected_year: findresponse.year,
                    user_id: findresponse.user_id,
                    all_quarters: findresponse.all_quarters,
                    all_years: findresponse.all_years,
                    page_name: "OKR: " + findresponse.quarter,
                })
                if (okr_quarter == '' || okr_quarter == null) {
                    okr_quarter = findresponse.quarter;
                    this.setState({ quarterlist: okr_quarter })
                }
                if (okr_year == '' || okr_year == null) {
                    okr_year = findresponse.year;
                    this.setState({ yearlist: okr_year })
                }
                if (okr_owner == '' || okr_owner == null) {
                    okr_owner = findresponse.user_id;
                }
                let arg = 'owner=' + okr_owner + '&year=' + okr_year + '&quarter=' + okr_quarter + '&search=' + okr_search;
                this.props.history.push('/listokr/?' + arg);

            })
    }


    onNewRequest(chosenRequest, index) {
        this.setState({
            ownerlist: chosenRequest.id,
            ownername: chosenRequest.title
        })
        localStorage.setItem('ownerlist', chosenRequest.id);
        this.setState({ ownerlist: chosenRequest.id, currentPage: this.state.currentPage }, function () {
            this.GetOkrListing(chosenRequest.id, this.state.quarterlist, this.state.yearlist, this.state.search, this.state.perPage, this.state.currentPage);
        });
    }


    handleUpdateInput = (searchText) => {
        if ((typeof searchText == "undefined") || (searchText == "") || (typeof searchText !== "string")) {
            searchText = '';
            if (this.state.ownerlist > 0) {
                this.setState({ ownerlist: '' });
                localStorage.setItem('ownerlist', '');
                this.GetOkrListing('', this.state.quarterlist, this.state.yearlist, this.state.search, this.state.perPage, this.state.currentPage);
            }
        }

        this.setState({ searchText: searchText });
    };


    getOwnersList(ownerText = '') {
        fetch(this.state.apiUrl + '/OkrRest/getOwner/userAuthKey/' + this.state.userAuthKey + '/searchText/' + ownerText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        user_search: findresponse.assign_to,
                        errorText: ''
                    })
                }
            })
    }

    getOwnerName(ownerId = '') {
        fetch(this.state.apiUrl + '/OkrRest/getOwnerName/userAuthKey/' + this.state.userAuthKey + '/ownerId/' + ownerId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        searchText: findresponse.assign_to['title'],
                    })
                } else {
                    this.setState({ searchText: '' })
                }
            })
    }
    showComment(comment) {
        if (comment) {
            this.setState({ show_comment: comment }, function () {
                window.$("#show_comments").modal('show');
            })
        }
    }

    renderChildData(data) {
        if (data.multi_keyresult.length > 0) {
            return data.multi_keyresult.map((dynamicData, key) => <div class="col-md-12 okr_card">
                {/* <td><div class="circle">{key + 1}</div>  <div class="key_result">{dynamicData.key_status==='Active'?<Link to={`/updateokr/${dynamicData.id}`}>{dynamicData.keyresult}</Link>:dynamicData.keyresult}</div></td> */}
                <div class="col-md-9 okr_keyresult">
                    <div class="okr_Sl">{key + 1}</div>
                    <p class="keyresult">
                        {dynamicData.keyresult.length > MAX_LENGTH ? dynamicData.keyresult.substring(0, MAX_LENGTH) + "...." : dynamicData.keyresult}
                        {dynamicData.init_count ?
                            <i class="xtra-text"> ({dynamicData.init_count} initiative)</i> : ""}
                    </p>
                </div>
                <div class="col-md-3">
                    <div class="review-area">
                        {(dynamicData.comment != "") ?
                            <button class="comment-btn" onMouseOver={() => this.showComment(dynamicData.comment)}>
                                <svg width="33" height="24" viewBox="0 0 33 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.91748" width="33" height="23" rx="11.5" fill="white" fill-opacity="0.04"></rect>
                                    <path d="M13.7915 9.70923H19.2082V10.7926H13.7915V9.70923ZM13.7915 11.8759H17.5832V12.9592H13.7915V11.8759Z" fill="#666666" fill-opacity="0.7"></path>
                                    <path d="M20.8335 7.00073H12.1668C11.5694 7.00073 11.0835 7.48661 11.0835 8.08407V17.8341L13.9722 15.6674H20.8335C21.431 15.6674 21.9168 15.1815 21.9168 14.5841V8.08407C21.9168 7.48661 21.431 7.00073 20.8335 7.00073ZM20.8335 14.5841H13.6115L12.1668 15.6674V8.08407H20.8335V14.5841Z" fill="#666666" fill-opacity="0.7"></path>
                                    <rect x="0.5" y="1.41748" width="32" height="22" rx="11" stroke="#666666" stroke-opacity="0.2"></rect>
                                </svg>
                            </button>
                            : ''}
                        {(dynamicData.key_status == 'Review') && (dynamicData.keyresult_review_status == 1) && (dynamicData.user_id == dynamicData.log_user || dynamicData.manager == dynamicData.log_user) ?
                            <a class={this.renderStatus(dynamicData.key_status, dynamicData.keyresult_review_status, 0)} onClick={() => this.setReview(dynamicData.id, dynamicData.okr_id)} data-toggle="modal" >{dynamicData.key_status}</a> : <div class={this.renderStatus(dynamicData.key_status, dynamicData.keyresult_review_status, 1)}>{dynamicData.key_status}</div>}
                    </div>
                </div>
            </div>)
        } else {
            return <div class="col-md-12 okr_card"><div class="col-md-10 okr_keyresult"><div class="keyresult">No key results found!</div></div></div>;
        }
    }

    resetPopupForm() {
        var FormData = this.state.formData;
        FormData.objective = "";
        FormData.keyRes = [{}]
        console.log(602, FormData)
        this.setState({
            formData: FormData,
            key: Date.now(),
            owner_error_message: '',
            show_keyRes_errors: [],
            show_errors: []
        });
        this.setState({ keyResult: [{ "child": [{}] }] }, function () {
            window.$("#addOKR").modal('show');
        });
    }

    /*ManageDynamicform() {
        this.setState({
            loading:true
        });

        fetch(this.state.apiUrl + '/OkrRest/ManageForm/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId,{
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
       .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
            
            formData.Owner = [findresponse.owner['id']];
            formData.Quarter = findresponse.quarter['quarter'];
            this.setState({
                schema:findresponse.form['schema'],
                uiSchema:findresponse.form['uiSchema'],
                quarter:findresponse.quarter['quarter'],
                year:findresponse.quarter['year'],
                formData:formData,
                searchText_popup:findresponse.owner['name'],
                page_name:"OKR : " + findresponse.quarter['year'] + " " + findresponse.quarter['quarter']
            });
            // alert(this.state.searchText_popup);
        })
    }*/

    getActiveOwner(searchText_popup = '') {
        fetch(this.state.apiUrl + '/OkrRest/getActiveOwner/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText_popup, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        search_popup: findresponse.assign_to,
                        errorText: ''
                    })
                } else {
                    this.setState({ errorText: findresponse.msg })
                }
            })
    }

    renderStatus(param, review, not_access) {
        switch (param) {
            case 'Review':
                if (review == 1 && not_access == 0) {
                    return 'review-btn';
                } else {
                    return 'okr_not_reviewed';
                }
            case 'Successful':
                return 'successful-btn';
            case 'Partly Successful':
                return 'unsuccessful-btn';
            case 'Failed':
                return 'failed-btn';
            default:
                return 'default-btn';
        }
    }

    componentDidMount() {
        var obj = this;

        document.title = "Intranet | OKR";

        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }

        function getUrlVars() {
            var url_value = {};
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                url_value[key] = value;
            });
            return url_value;
        }

        let url_quarter = '';
        let url_year = '';
        let url_user = '';
        let url_search = '';

        if (window.location.search != '') {

            var url_vars = getUrlVars();

            if (url_vars.hasOwnProperty('quarter')) {
                //                url_quarter = getUrlVars()["quarter"].replace(/%20/g, " ");
                url_quarter = getUrlVars()["quarter"];
            }

            if (url_vars.hasOwnProperty('search')) {
                url_search = getUrlVars()["search"].replace(/%20/g, " ");
            }

            if (url_vars.hasOwnProperty('owner')) {
                url_user = getUrlVars()["owner"];
            }
            if (url_vars.hasOwnProperty('year')) {
                url_year = getUrlVars()["year"];
            }

        } else {
            url_year = localStorage.getItem('yearlist');
            url_quarter = localStorage.getItem('quarterlist');
            url_user = obj.state.userId;//localStorage.getItem('ownerlist');
        }

        localStorage.setItem('search', url_search);
        localStorage.setItem('ownerlist', url_user);
        localStorage.setItem('quarterlist', url_quarter);
        localStorage.setItem('yearlist', url_year);
        //return false;
        this.getOwnersList();

        // console.log(this.state.user_search);

        this.setState({ 'ownerlist': url_user });
        this.setState({ 'quarterlist': url_quarter });
        this.setState({ 'yearlist': url_year });
        this.setState({ 'search': url_search });

        this.getOwnerName(url_user);

        this.GetOkrListing(url_user, url_quarter, url_year, url_search);
        // ER70270>>Bug Er71830 shoe ex emp on listing but not on Add OKR popup
        // this.getOwner();
        this.getActiveOwner();
        //        this.ManageDynamicform();
    }

    handleValidation() {
        var obj = this;
        var formData = this.state.formData;
        var show_keyRes_errors = this.state.show_keyRes_errors;
        var objective = formData.objective;
        objective = objective.trim();
        var formSubmit = true;
        if (!objective) {
            show_keyRes_errors['objective'] = "Please enter your objective";
            this.setState({ show_keyRes_errors });
            formSubmit = false;
        }
        formData.keyRes.map(function (result, index) {
            if (!result.hasOwnProperty('txt')) {
                show_keyRes_errors[index] = "Please enter your key result";
                formSubmit = false;
            }
            if (result.hasOwnProperty('txt')) {
                if (result.txt.trim().length == 0) {
                    show_keyRes_errors[index] = "Please enter your key result";
                    formSubmit = false;
                }
                if (result.txt.length > obj.state.maxLength) {
                    show_keyRes_errors[index] = "Key result should not be longer than 120 characters";
                }
            }

        })
        this.setState({ show_keyRes_errors });
        return formSubmit;
    }
    submitUser() {
        var formData = this.state.formData;
        formData.keyRes = this.state.keyResult;
        this.setState({ formData }, function () {
            var validate = this.handleValidation(this.state.formData);
            if (!validate) {
                return false;
            }
            this.setState({ waiting: 'loading' });
            let api_url = this.state.apiUrl + '/OkrRest/InsertOkrnew/userAuthKey/' + this.state.userAuthKey;
            fetch(api_url, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify({ 'formData': this.state.formData, 'userId': this.state.userId }),
            })
                .then((response) => response.json())
                .then((result) => {
                    result = this.decrypt(result, 1);
                    this.setState({ waiting: '' });
                    if (result.code === 200) {
                        // URL issue
                        let arg = 'owner=' + (result.userId) + '&year=' + (result.current_year) + '&quarter=' + (result.current_quarter) + '&search=' + ('');
                        window.$("#addOKR").modal('hide');
                        //   window.location.href = '/listokr/?' + arg;
                        this.Reset();
                    } else {
                        this.setState({
                            error_message: result.msg,
                            formData: this.state.formData,
                        });
                    }
                    this.setState({ waiting: '' });
                })
            return false;
        });

    }

    addKeyResult(event, keyres_index, init_index, txt_val) {
        if (txt_val) {
            if (txt_val == "keyres_value") {
                var keyRes_txt = this.state.keyResult;
                var target_val = event.target.value;
                keyRes_txt[keyres_index].txt = event.target.value;
                var show_keyRes_errors = this.state.show_keyRes_errors;
                if (target_val.length > 1 && target_val.length < this.state.maxLength) {
                    show_keyRes_errors[keyres_index] = "";
                } else if (target_val.length == this.state.maxLength) {
                    show_keyRes_errors[keyres_index] = "Key Result should not be longer than " + this.state.maxLength + " characters";
                }
                this.setState({ keyResult: keyRes_txt, show_keyRes_errors }, function () {
                    console.log(768, this.state.keyResult);
                });
            } else if (txt_val == "init_value") {
                var keyRes_txt = this.state.keyResult;
                keyRes_txt[keyres_index].child[init_index] = event.target.value;
                var target_val = event.target.value;
                var show_init_errors = this.state.show_init_errors;
                if (target_val.length > 1 && target_val.length < this.state.maxLength) {
                    show_init_errors[init_index] = "";
                } else if (target_val.length == this.state.maxLength) {
                    show_init_errors[init_index] = "Initiative should not be longer than " + this.state.maxLength + " characters";
                }
                this.setState({ keyResult: keyRes_txt, show_init_errors }, function () {
                    console.log(768, this.state.keyResult);
                });
            } else if (txt_val == "objective") {
                let formData = this.state.formData;
                var show_keyRes_errors = this.state.show_keyRes_errors;
                var target_val = event.target.value;
                if (target_val.length > 1 && target_val.length < this.state.maxLength) {
                    show_keyRes_errors['objective'] = "";
                } else if (target_val.length == this.state.maxLength) {
                    show_keyRes_errors['objective'] = "Objective should not be longer than " + this.state.maxLength + " characters";
                }
                formData[event.target.name] = event.target.value;
                this.setState({ formData, show_keyRes_errors });
            }

        } else {
            var keyResult = this.state.keyResult.slice();
            var keyRes_init = Array(1).fill({ "child": [{}] });

            var resultant_arr = [...this.state.keyResult, ...keyRes_init];
            if (keyres_index > -1) {
                //add more part for initiative
                if (this.state.keyResult[keyres_index].child.length < 3) {
                    var initiative = {};
                    var existing_keyres = this.state.keyResult[keyres_index].child;
                    this.state.keyResult[keyres_index].child.push(initiative);
                    setTimeout(() => {
                        this.setState({ ...this.state, keyResult: this.state.keyResult }, function () {
                            var last_key = this.state.keyResult[keyres_index].child.length - 2;
                            var div = document.querySelector("#initbtn_" + keyres_index + "_" + last_key);
                            if (div) {
                                $(".child-inner-bottom").animate({
                                    scrollTop: div.offsetTop
                                }, 1000);
                            }
                        })
                    }, 500);
                } else {
                    var show_errors = this.state.show_errors;
                    show_errors[keyres_index] = "Only 3 initiatives can be added";
                    this.setState({ show_errors });
                    return false;
                }
            } else {
                //add more part for keyresult block
                setTimeout(() => {
                    this.setState({ ...this.state, keyResult: resultant_arr }, function () {
                        var last_key = this.state.keyResult.length - 1;
                        var div = document.querySelector("#delKeyBtn_" + last_key);
                        if (div) {
                            $(".child-inner-bottom").animate({
                                scrollTop: div.offsetTop
                            }, 1000);
                        }
                    })
                }, 500);
            }
        }
    }

    confirmWindow(event, keyres_index, intiative_index) {
        if ((intiative_index != '') && (intiative_index > -1)) {
            this.setState({ deletePopup: "Are you sure to remove this initiative", whomToDelete: event.target.name, keyres_index, intiative_index }, function () {
                window.$("#deletePopup").modal('show');
            });
        } else {
            this.setState({ deletePopup: "Are you sure to remove this keyResult", whomToDelete: event.target.name, keyres_index }, function () {
                window.$("#deletePopup").modal('show');
            });
        }
    }

    proceedToDelete(e) {
        window.$("#deletePopup").modal('hide');
        this.removeKeyResults(e, this.state.keyres_index, this.state.intiative_index);
    }

    removeKeyResults(e, keyres_index, intiative_index) {
        var whomToDelete = this.state.whomToDelete;
        if (whomToDelete == "deleteinit") {
            var new_keyres = this.state.keyResult[keyres_index].child.splice(intiative_index, 1);
            if (this.state.keyResult[keyres_index].child.length < 3) {
                var show_errors = this.state.show_errors;
                show_errors[keyres_index] = "";
                this.setState({ show_errors }, function () {
                    console.log(904, this.state.show_errors);
                });
            }
        } else if (whomToDelete == "deletekeyres") {
            var new_keyres = this.state.keyResult.splice(keyres_index, 1);
        }
        this.setState({ keyResult: this.state.keyResult });
    }

    onChangeForm(event) {
        let formData = this.state.formData;
        formData[event.target.name] = event.target.value;
        this.setState({ formData });
    }
    render() {
        let self = this;
        const SampleExpandedComponent = ({ data }) => this.renderChildData(data);

        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }

        return (
            <div>
                <Header brecum_name="ER" brecum_page="OKR" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob"><HeaderMob page_name="OKR" /></div>
                        <div class="okr-child-fullbox">
                            <div class="child-head">
                                <div class="head-top">
                                    <div class="left-content">
                                        <div class="left-content">
                                            <div class="select-area">
                                                <select id="yearlist" class="select-cls" name="yearlist" value={this.state.yearlist} onChange={(e) => this.quarterChangelist(e, 'yearlist')} >
                                                    <option key="All">All</option>
                                                    {console.log(979, this.state.all_years)}
                                                    {this.state.all_years.map((x, y) =>
                                                        <option key={y}>{x}</option>)
                                                    }
                                                </select>
                                            </div>
                                            <div class="select-area">
                                                <select id="quarterlist" class="select-cls" name="quarterlist" value={this.state.quarterlist} onChange={(e) => this.quarterChangelist(e, 'quarterlist')} >
                                                    <option key="All">All</option>
                                                    <option key="Q1">Q1</option>
                                                    <option key="Q2">Q2</option>
                                                    <option key="Q3">Q3</option>
                                                    <option key="Q4">Q4</option>
                                                </select>
                                            </div>
                                            <div class="owner-area">
                                                <div class="owner-text">Owner</div>
                                                <div class="warden-name">
                                                    <MuiThemeProvider muiTheme={getMuiTheme()} class="form-control">
                                                        <AutoComplete
                                                            id="autocomplete"
                                                            // onChange={(e) => this.UpdateKeyresult(item.attribute)}
                                                            onUpdateInput={this.handleUpdateInput}
                                                            onNewRequest={this.onNewRequest.bind(this)}
                                                            onClick={this.handleUpdateInput}
                                                            onChange={(event, option) => {
                                                                console.log(option); // 1
                                                            }}
                                                            //onKeyDown={this.handleAutocompleteKey}
                                                            fullWidth={true}
                                                            placeholder="Type here to search Owner"
                                                            filter={AutoComplete.caseInsensitiveFilter}
                                                            dataSource={this.state.user_search}
                                                            dataSourceConfig={dataSourceConfig}
                                                            errorStyle={{ bottom: 0 }}
                                                            errorText={this.state.errorText}
                                                            maxSearchResults={500}
                                                            className="okr_search_box"
                                                            searchText={this.state.searchText}
                                                            openOnFocus={true}
                                                            menuStyle={{ maxHeight: '160px' }}
                                                        />
                                                    </MuiThemeProvider>
                                                </div>
                                            </div>
                                            <div class="search-area">
                                                <input type="text" class="search-input" autocomplete="off" name="search" id="search" placeholder="Search objectives" value={this.state.search} onChange={this.searchChange} />
                                                <div class="tooltips">
                                                    <div class="tooltiptext">Reset</div>
                                                    <span class="reset" onClick={() => this.Reset()}><i class="fas fa-undo"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right-content">
                                        <div class="button-area">
                                            <button data-toggle="modal" onClick={() => this.resetPopupForm()}>Add OKR</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DataTable
                            columns={this.columns}
                            data={this.state.data}
                            pagination
                            className='data-table-list'
                            responsive={true}
                            //selectableRows='true'
                            // progressPending={this.state.loading}
                            paginationTotalRows={this.state.totalRows}
                            paginationServer={true}
                            onChangePage={this.ChangePage}
                            onChangeRowsPerPage={this.ChangeRowsPerPage}
                            paginationPerPage={this.state.perPage}
                            paginationRowsPerPageOptions={[10, 20, 50, 100]}
                            noHeader={true}
                            expandableRows={true}
                            expandableRowExpanded={row => row.defaultExpanded}
                            //expandOnRowClicked={true}
                            expandableRowsComponent={<SampleExpandedComponent />
                            }
                            expandableIcon={{
                                collapsed: <svg fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" /><line x1="12" x2="12" y1="8" y2="16" /><line x1="8" x2="16" y1="12" y2="12" /></svg>,
                                expanded: <svg fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" /><line x1="8" x2="16" y1="12" y2="12" /></svg>
                            }}
                            // expandableRowsComponent={this.keyresult()}
                            customStyles={customStyles}
                        />
                        <div class="review_popup">
                            <div class="modal fade" id="changegrouptype" data-backdrop='static' data-keyboard='false' tabindex="-1" role="dialog" aria-labelledby="Deal" aria-hidden="true" >
                                <div class="modal-dialog modal-dialog-centered" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <div class="top-head">
                                                <div class="review-title">Reviewing Key Result</div>
                                                <div>
                                                    <button type="button" class="close" data-dismiss="modal">
                                                        <svg width="23" height="26" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M9.89949 13L5.65685 8.75736C5.26633 8.36684 5.26633 7.73367 5.65685 7.34315C6.04738 6.95262 6.68054 6.95262 7.07107 7.34315L11.3137 11.5858L15.5563 7.34315C15.9469 6.95262 16.58 6.95262 16.9706 7.34315C17.3611 7.73367 17.3611 8.36683 16.9706 8.75736L12.7279 13L16.9706 17.2426C17.3611 17.6332 17.3611 18.2663 16.9706 18.6569C16.58 19.0474 15.9469 19.0474 15.5563 18.6569L11.3137 14.4142L7.07107 18.6569C6.68054 19.0474 6.04738 19.0474 5.65685 18.6569C5.26633 18.2663 5.26633 17.6332 5.65685 17.2426L9.89949 13Z" fill="#586472" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-body">
                                            <div class="all-tag">
                                                {this.state.okr_review && this.state.okr_review.length > 0 ?
                                                    this.state.okr_review.map((dynamicData, key) =>
                                                        <label class={'switch ' + (dynamicData.review_cls ? dynamicData.review_cls : "")}>
                                                            <input type="radio" name="review_id" value={dynamicData.key} checked={dynamicData.key == this.state.update_review_id ? this.state.radioChecked : ""} onChange={(val) => this.handleReviewValidation(val, val.target.value)} />
                                                            <span class="slider round">{dynamicData.value}</span>
                                                        </label>
                                                    ) : ""
                                                }
                                            </div>
                                            {this.state.review_error_message ? <div class="text-danger">{this.state.review_error_message}</div> : ""}
                                            <div class="control-area">
                                                <div class="input-label">Share your comment (Optional)</div>
                                                <textarea placeholder="Write Here" name="review_comment" maxLength={this.state.maxLengthComment} value={this.state.update_review_comment} onChange={(val) => this.handleReviewValidation(val, val.target.value)}></textarea>
                                                <div class="text-danger">{this.state.show_errors && this.state.show_errors.hasOwnProperty('comment_error') ? this.state.show_errors['comment_error'] : ''}</div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="cancel-btn" data-dismiss="modal">Cancel</button>
                                            {this.state.waiting ?
                                                <button type="submit" class="save-btn disabled" ><div><i class="fa fa-spinner fa-spin"></i><span> Reviewing</span></div></button>
                                                :
                                                <button type="button" class="save-btn" onClick={() => this.SaveGroupType()} >Review</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="addokr_popup">
                    <div class="modal fade in" id="addOKR" data-backdrop='static' data-keyboard='false' tabindex="-1" role="dialog" aria-labelledby="Deal" aria-hidden="true" >
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="top-head">
                                        <div class="addokr_title">Add OKR ({this.state.selected_year}-{this.state.quarter})</div>
                                        <div>
                                            <button type="button" class="close" data-dismiss="modal">
                                                <svg width="23" height="26" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.89949 13L5.65685 8.75736C5.26633 8.36684 5.26633 7.73367 5.65685 7.34315C6.04738 6.95262 6.68054 6.95262 7.07107 7.34315L11.3137 11.5858L15.5563 7.34315C15.9469 6.95262 16.58 6.95262 16.9706 7.34315C17.3611 7.73367 17.3611 8.36683 16.9706 8.75736L12.7279 13L16.9706 17.2426C17.3611 17.6332 17.3611 18.2663 16.9706 18.6569C16.58 19.0474 15.9469 19.0474 15.5563 18.6569L11.3137 14.4142L7.07107 18.6569C6.68054 19.0474 6.04738 19.0474 5.65685 18.6569C5.26633 18.2663 5.26633 17.6332 5.65685 17.2426L9.89949 13Z" fill="#586472"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div class="top-inner-body">
                                        <div class="row form-group">
                                            <div class="col-md-12">
                                                <div class="label-title">Objective <span class="required">*</span></div>
                                            </div>
                                            <div class="col-md-12">
                                                {console.log(1075, this.state.show_keyRes_errors)}
                                                <input type="text" autocomplete="off" class="form-control" maxlength={this.state.maxLength} placeholder="Write Here" name="objective" id="objective" value={this.state.formData.objective} onChange={(e) => this.addKeyResult(e, " ", " ", 'objective')} />
                                                <span class="error">{this.state.show_keyRes_errors ? this.state.show_keyRes_errors['objective'] : ""}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bottom-inner-body">
                                        <div class="child-inner-bottom">
                                            {console.log(1092, this.state.keyResult)}
                                            {this.state.keyResult.map((item, key) =>
                                                <div id={'keyRes' + key} class={'single-add' + (key > 0 ? " mt20" : "")}>
                                                    <div class="top-area">
                                                        {console.log(1110, item)}
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="label-title">Key Result {key + 1} <span class="required">*</span></div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" autocomplete="off" class="form-control" maxlength={this.state.maxLength} atr="sadasd" placeholder="Write Here" id={`keyResText_${key}`} value={item.hasOwnProperty('txt') ? item.txt : ''} onChange={(e) => this.addKeyResult(e, key, " ", 'keyres_value')} />
                                                                <span class="error">{this.state.show_keyRes_errors ? this.state.show_keyRes_errors[key] : ""}</span>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-20" >
                                                            <div class="col-md-12">
                                                                <div class="label-title">Initiative</div>
                                                                <div class="error marg-err">{this.state.show_errors[key] ? this.state.show_errors[key] : ""}</div>
                                                            </div>
                                                            {item['child'].map((item1, key1) =>
                                                                <div class={`col-md-12 ${key1 > 0 ? 'mt20' : ''}`}>
                                                                    <div class="divide-area">
                                                                        <div class="left-control">
                                                                            <input type="text" autocomplete="off" class="form-control" maxlength={this.state.maxLength} placeholder="Write Here" id={`initText_${key}_${key1}`} value={item1.length > 0 ? item1 : ''} onChange={(e) => this.addKeyResult(e, key, key1, 'init_value')} />
                                                                            <span class="error">{this.state.show_init_errors ? this.state.show_init_errors[key1] : ""}</span>
                                                                        </div>
                                                                        <div class="right-button">
                                                                            {key1 == 0 ?
                                                                                <button id={`initbtn_${key}_${key1}`} onClick={(e) => this.addKeyResult(e, key)}>
                                                                                    <span>
                                                                                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <path d="M8 3.83333V13.1667" stroke="#666666" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                                            <path d="M3.3335 8.5H12.6668" stroke="#666666" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                    Add
                                                                                </button>
                                                                                :
                                                                                <button id={`initbtn_${key}_${key1}`} name="deleteinit" onClick={(e) => this.confirmWindow(e, key, key1)}>- Remove</button>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div class="bottom-area">
                                                        {this.state.keyResult.length > 1 ?
                                                            <button name="deletekeyres" onClick={(e) => this.confirmWindow(e, key)} id={`delKeyBtn_${key}`}>
                                                                <span>
                                                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M2.25 4.0625H3.41667H12.75" stroke="#929292" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                        <path d="M5.1665 4.06251V2.89584C5.1665 2.58642 5.28942 2.28967 5.50821 2.07088C5.72701 1.85209 6.02375 1.72917 6.33317 1.72917H8.6665C8.9759 1.72917 9.27265 1.85209 9.49145 2.07088C9.71026 2.28967 9.83317 2.58642 9.83317 2.89584V4.06251H5.1665ZM11.5832 4.06251V12.2292C11.5832 12.5386 11.4603 12.8353 11.2415 13.0541C11.0226 13.2729 10.7259 13.3958 10.4165 13.3958H4.58317C4.27375 13.3958 3.97701 13.2729 3.75821 13.0541C3.53942 12.8353 3.4165 12.5386 3.4165 12.2292V4.06251H11.5832Z" stroke="#929292" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                        <path d="M6.3335 6.97917V10.4792" stroke="#929292" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                        <path d="M8.6665 6.97917V10.4792" stroke="#929292" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                    </svg>
                                                                </span>
                                                                Delete Key Result &amp; Intiative
                                                            </button>
                                                            : ""}
                                                    </div>
                                                </div>)}
                                        </div>
                                    </div>
                                    <div class="newAdd-key">
                                        <button onClick={(e) => this.addKeyResult()}>
                                            <span>
                                                {/* icon and colour change */}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 28 28" fill="none">
                                                    <g clip-path="url(#clip0_331_3670)">
                                                        <path d="M14 27.4928C21.732 27.4928 28 21.3665 28 13.8095C28 6.25242 21.732 0.126221 14 0.126221C6.26801 0.126221 0 6.25242 0 13.8095C0 21.3665 6.26801 27.4928 14 27.4928ZM13 8.92261C13 8.66339 13.1054 8.41479 13.2929 8.2315C13.4804 8.04821 13.7348 7.94523 14 7.94523C14.2652 7.94523 14.5196 8.04821 14.7071 8.2315C14.8946 8.41479 15 8.66339 15 8.92261V12.8321H19C19.2652 12.8321 19.5196 12.9351 19.7071 13.1184C19.8947 13.3017 20 13.5503 20 13.8095C20 14.0687 19.8947 14.3173 19.7071 14.5006C19.5196 14.6839 19.2652 14.7869 19 14.7869H15V18.6963C15 18.9556 14.8946 19.2042 14.7071 19.3875C14.5196 19.5708 14.2652 19.6737 14 19.6737C13.7348 19.6737 13.4804 19.5708 13.2929 19.3875C13.1054 19.2042 13 18.9556 13 18.6963V14.7869H8.99999C8.73479 14.7869 8.48043 14.6839 8.2929 14.5006C8.10535 14.3173 8 14.0687 8 13.8095C8 13.5503 8.10535 13.3017 8.2929 13.1184C8.48043 12.9351 8.73479 12.8321 8.99999 12.8321H13V8.92261Z" fill="#006EFA" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_331_3670">
                                                            <rect width="28" height="28" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </span>
                                            Add Key Result &amp; Initiative
                                        </button>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button class="cancel-btn" data-dismiss="modal">Cancel</button>
                                    {this.state.waiting ?
                                        <button type="button" id="add_user_btn" class="save-btn disabled" ><div><i class="fa fa-spinner fa-spin"></i><span> Submitting</span></div></button>
                                        : <button type="button" class="save-btn" onClick={this.submitUser}>Publish</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="delete_popup">
                    <div class="modal fade" id="deletePopup" data-backdrop='static' data-keyboard='false' tabindex="-1" role="dialog" aria-labelledby="Deal" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="top-area">
                                            <div class="left-icon">
                                                <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.9633 1.52871C11.9006 1.46668 11.826 1.41749 11.7438 1.38396C11.6617 1.35044 11.5736 1.33325 11.4847 1.33337H6.06935C5.98044 1.33325 5.89239 1.35044 5.81025 1.38396C5.72811 1.41749 5.65352 1.46668 5.59077 1.52871L2.20615 4.86204C2.14317 4.92385 2.09322 4.99731 2.05918 5.0782C2.02514 5.15909 2.00768 5.24581 2.00781 5.33337V10.6667C2.00781 10.844 2.07889 11.0134 2.20615 11.138L5.59077 14.4714C5.65352 14.5334 5.72811 14.5826 5.81025 14.6161C5.89239 14.6496 5.98044 14.6668 6.06935 14.6667H11.4847C11.6648 14.6667 11.8367 14.5967 11.9633 14.4714L15.3479 11.138C15.4109 11.0762 15.4609 11.0028 15.4949 10.9219C15.5289 10.841 15.5464 10.7543 15.5463 10.6667V5.33337C15.5464 5.24581 15.5289 5.15909 15.4949 5.0782C15.4609 4.99731 15.4109 4.92385 15.3479 4.86204L11.9633 1.52871ZM9.45397 11.3334H8.10012V10H9.45397V11.3334ZM9.45397 8.66671H8.10012V4.66671H9.45397V8.66671Z" fill="#E31D1C" />
                                                </svg>
                                            </div>
                                            <div class="right-content">
                                                <div class="confirm-title">{this.state.deletePopup}</div>
                                                <div class="description">Confirming this action will delete this block here and it will be removed from the form. Do you want to proceed ?</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="button-area">
                                            <button class="cancel-btn" data-dismiss="modal">Cancel</button>
                                            <button class="proceed-btn" onClick={(e) => this.proceedToDelete()}>Proceed</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="show_feedback">
                    <div class="modal fade" id="show_comments" data-backdrop='static' role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Comment</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="commentDiv">
                                        {this.state.show_comment}
                                    </div>
                                </div>
                                <div class="okr-footer modal-footer">
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Er 66487: Pause popup end */}

            </div>
        )
    }
}
export default Listokr;


// WEBPACK FOOTER //
// ./src/components/okr/listokr.js